import { css } from '@landr/styled-system/css';

// Define styles using Panda CSS
export const packIcon = css({
    width: { base: 'sm', md: 'sizes.7' },
    height: { base: 'sm', md: 'sizes.7' },
    borderRadius: 'xs',
});

export const wrapperLinkPackIcon = css({
    width: { base: 'sm', md: 'sizes.7' },
    height: { base: 'sm', md: 'sizes.7' },
    display: 'block',
});
